/**
 * @generated SignedSource<<ddfe13df40be7bdac68ac47fb8db28b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCastPanelOwnFeedbackFragment$data = {
  readonly delegate?: {
    readonly proposalFeedback: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"FeedbackRowFragment">;
    }>;
  };
  readonly " $fragmentType": "FeedbackCastPanelOwnFeedbackFragment";
};
export type FeedbackCastPanelOwnFeedbackFragment$key = {
  readonly " $data"?: FeedbackCastPanelOwnFeedbackFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelOwnFeedbackFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "address"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "proposalId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skipAddress"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackCastPanelOwnFeedbackFragment",
  "selections": [
    {
      "condition": "skipAddress",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "addressOrEnsName",
              "variableName": "address"
            }
          ],
          "concreteType": "Delegate",
          "kind": "LinkedField",
          "name": "delegate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "proposalId",
                  "variableName": "proposalId"
                }
              ],
              "concreteType": "ProposalFeedback",
              "kind": "LinkedField",
              "name": "proposalFeedback",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FeedbackRowFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4a1cc3bc0171a814ecaaf49c59726ad9";

export default node;
